import { render, staticRenderFns } from "./searchUniversityDialog.vue?vue&type=template&id=c3d6dff2"
import script from "./searchUniversityDialog.vue?vue&type=script&lang=js"
export * from "./searchUniversityDialog.vue?vue&type=script&lang=js"
import style0 from "./searchUniversityDialog.vue?vue&type=style&index=0&id=c3d6dff2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports